var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconToolScissor = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24.25,
  height: 20.25,
  viewBox: "0 0 24.25 20.25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-.375-2.375h25v25h-25z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.625 .625)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 3.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.648 8.232 23 15.587a2.214 2.214 0 0 1-2.905.75L4.154 6.939"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 15.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.779 9.501 23 3.414a2.213 2.213 0 0 0-2.905-.75L4.154 12.061"
})))));
export { SvgIconToolScissor as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-tool-scissor.svg";